module.exports = __webpack_public_path__ + "img/chart.2b4a74c3.svg";